import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AddEditSubmenuComponent } from '../addeditsubmenu/addeditsubmenu.component';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
import { AdminService } from '../services/admin.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from 'angular2-notifications';
@Component({
    selector: 'app-sidebar-submenu',
    templateUrl: './sidebar-submenu.component.html',
    styleUrls: ['./sidebar-submenu.component.css']
})
export class SidebarSubmenuComponent implements OnInit {
    displayedColumns = [
        'parentmenu',
        'menu',
        'menu_url',
        'order',
        'status',
        'styleclass',
        'action'
    ];
    public dataSource: any = new MatTableDataSource();
    pageSize = 20;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    @ViewChild('paginator', null) paginator: MatPaginator;
    @ViewChild('sort') sort: MatSort;
    constructor(
        public dialog: MatDialog,
        public adminService: AdminService,
        public notifSer : NotificationsService
    ) { }

    ngOnInit() {
        this.getAdminMenus();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    refreshAdminMenus() {
        this.getAdminMenus();
    }
    getAdminMenus() {
        this.adminService.getAdminMenus().subscribe(menus => {
            const flattenedArray = menus.flatMap(item => {
                return item.submenu.map(subitem => {
                    return {
                        _id: subitem._id,
                        menu: subitem.menu,
                        menu_url: subitem.menu_url,
                        order: subitem.order,
                        styleclass: subitem.styleclass,
                        status: subitem.status,
                        parentmenu: item.menu, // Use the parent menu name
                        parentmenu_url: item.menu_url // Use the parent menu URL if needed
                    };
                });
            });
            this.dataSource = new MatTableDataSource(flattenedArray);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

        })
    }
    deleteAdminMenu(id) {
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete menu?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.adminService.deleteAdminMenu(id).subscribe(delRes => {
                        if (delRes) {
                            this.notifSer.success('Success', delRes.message, notif)
                            this.getAdminMenus();
                        }
                        else this.notifSer.error('Error', delRes.message, notif)
                    })
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    createSubMenu(element) {
        var new_element = {}
        if (element) {
            new_element = {
                _id : element._id,
                parent_menu: element.parentmenu,
                sub_menu: element.menu,
                menu_url: element.menu_url,
                is_active: element.status,
                order: element.order,

            }
        } else {
            new_element = {
                _id: '',
                parent_menu: '',
                sub_menu: '',
                menu_url: '',
                is_active: '',
                order: '',

            }
        }
        this.dialog.open(AddEditSubmenuComponent, {
            data: new_element,
            width: 'auto',
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                this.getAdminMenus();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/sidebar-submenu/sidebar-submenu.component.ts